import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '~/core/classes/auth/auth.guard';

//******************************************************************************
//  App Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { GuideComponent } from '~/pages/guide/guide.component';
import { CitationsComponent } from '~/pages/citations/citations.component';

export const routes: any[] = [
    {
        path: '',
        title: 'Sentry',
        isNav: true,
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'refinery/:refineryId',
        title: (snapshot: any) => {
            const refineryId = snapshot?.params?.['refineryId'] ?? '';
            return refineryId ? `Sentry - ${refineryId.toUpperCase()}` : 'Sentry - Refinery';
        },
        isNav: false,
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'refinery/:refineryId/unit/:unitId',
        title: (snapshot: any) => {
            const refineryId = snapshot?.params?.['refineryId'] ?? '';
            const unitId = snapshot?.params?.['unitId'] ?? '';

            if (refineryId && unitId) {
                return `Sentry - ${refineryId.toUpperCase()} - ${unitId.toUpperCase()}`;
            }

            return 'Sentry - Unit';
        },
        isNav: false,
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'refinery/:refineryId/unit/:unitId/run/:runId',
        title: (snapshot: any) => {
            const runId = snapshot?.params?.['runId'] ?? '';
            return runId ? `Sentry - ${runId}` : 'Sentry - Run';
        },
        isNav: false,
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'run/:runId',
        title: (snapshot: any) => {
            const runId = snapshot?.params?.['runId'] ?? '';
            return runId ? `Sentry - ${runId}` : 'Sentry - Run';
        },
        isNav: false,
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'run/:runId/guide',
        title: (snapshot: any) => {
            const runId = snapshot?.params?.['runId'] ?? '';
            return runId ? `Sentry - ${runId} - Guide` : 'Sentry - Run Guide';
        },
        isNav: false,
        component: GuideComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'refinery/:refineryId/unit/:unitId/run/:runId/citations/:assetTag',
        title: (snapshot: any) => {
            const runId = snapshot?.params?.['runId'] ?? '';
            const assetTag = snapshot?.params?.['assetTag'] ?? '';

            if (runId && assetTag) {
                return `Sentry - ${runId} - ${assetTag}`;
            }

            return 'Sentry - Run Citations';
        },
        isNav: false,
        component: CitationsComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'refinery/:refineryId/unit/:unitId/run/:runId/citations/:assetTag/guide',
        title: (snapshot: any) => {
            const runId = snapshot?.params?.['runId'] ?? '';
            const assetTag = snapshot?.params?.['assetTag'] ?? '';

            if (runId && assetTag) {
                return `Sentry - ${runId} - ${assetTag} - Guide`;
            }

            return 'Sentry - Run Citations Guide';
        },
        isNav: false,
        component: GuideComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'guide',
        title: 'Sentry - Guide',
        isNav: false,
        component: GuideComponent,
        canActivate: [AuthGuard]
    },
   
    {
        path: '**',
        redirectTo: 'notfound',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRouting { }
